import { useContext, useEffect, useState } from "react";
import { requester } from "App";
import { useParams } from "react-router-dom";
import { OutletContext } from "./../../../front/main/WebSocketContainer";
import P from "components/P";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";

function VendorStockList({ items }) {

    const fontSize = 'max(1.2vw, 10px)';
    console.log("items : ", items);
    return (
        <VerticalFlex
            backgroundColor="white"
            padding="max(1vw, 10px)"
            borderRadius="1rem"
        >
            <FlexChild alignItems="flex-start">
                {/* <P size="max(1.4vw, 10px)" padding="0 0 1rem" weight={700}>
                    자판기 내 상품 재고 현황
                </P> */}
                {/* <button onClick={() => console.log(lowStockProducts)}>5개 미만 제품 리스트</button> */}
                <div
                    style={{
                        borderBottom: "1px solid #eee",
                    }}
                >
                    <HorizontalFlex padding="0 0 1rem" gap="1rem">
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                제품이름
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                재고
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                5개미만인 제품
                            </P>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
                <div>
                    {items.map((store, index) => (
                        <HorizontalFlex padding="1em 0" gap="1em" key={index}>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild alignItems="flex-start">
                                        <P size={fontSize}>
                                            {store.productName}
                                        </P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild alignItems="flex-start">
                                        <P size={fontSize}>
                                            {store.quantity}
                                        </P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                            <FlexChild>
                                <VerticalFlex>
                                    <FlexChild alignItems="flex-start">
                                        <P size={fontSize} color={"red"} weight={"bold"}>
                                            {store.quantity < 5 ? "재고부족" : ""}
                                        </P>
                                    </FlexChild>
                                </VerticalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    ))}
                </div>
            </FlexChild>
        </VerticalFlex>
    )

}
export default VendorStockList;